import { SpotEntityMapper } from '../spot/entityMapper'
import MediaRepository from '../media/repository'
import { SiteRepository } from './repository'
import { PaginateSpots, Spot2 } from '~/models/Spot'
import { Marker2 as Marker } from '~/models/Marker'
import { SiteEntityMapper } from '~/passporter-services/site/entityMapper'
import Block, { Block2, BlockContentType } from '~/models/Block'
import { SiteInfo2 } from '~/models/SiteInfo'
import { BlockEntityMapper } from '~/passporter-services/block/entityMapper'
import { Site2 as Site } from '~/models/Site'
import { Destination2 } from '~/models/Destination'
import Product, { PRODUCT_CATEGORY } from '~/models/Product'

export default class SiteService {
	repository: any
	constructor(repository: any) {
		this.repository = repository
	}

	async getSpotsSite(siteId: string): Promise<PaginateSpots> {
		const res = await this.repository.getSpotsSite(siteId)
		const { data } = res
		const paginatedSpots = SpotEntityMapper.toPaginatedSpots(data)
		return paginatedSpots
	}

	async obtainBy(idOrSubdomain: string): Promise<Site> {
		const res = await this.repository.getSite(idOrSubdomain)
		const { data } = res
		return SiteEntityMapper.toSite(data)
	}

	async obtainGuidesFromSite(id: string): Promise<Block<BlockContentType>[]> {
		const { data } = await this.repository.getGuides(id)
		const results = data.results
		return BlockEntityMapper.toBlocks(results)
	}

	async obtainMarkers(id: string): Promise<Marker[]> {
		const res = await this.repository.markers(id)
		const { data } = res
		const markers = SpotEntityMapper.toMarkers(data)
		return markers
	}

	async getItineraryBlocks(id: string): Promise<Array<Block<BlockContentType>> | undefined> {
		const res = await this.repository.getItinearyBlocks(id)
		const data = res.data

		const areItems = data.results && data.results.length > 0
		if (!areItems) return

		return BlockEntityMapper.toBlocks(data.results)
	}

	async getDestinationBlocks(id: string): Promise<Block<BlockContentType>[]> {
		const res = await this.repository.getDestinationBlocks(id)
		const { data } = res
		return BlockEntityMapper.toBlocks(data.results)
	}

	async getProductBlocks(id: string): Promise<Block<BlockContentType>[]> {
		const res = await this.repository.getProductBlocks(id)
		const { data } = res
		return BlockEntityMapper.toBlocks(data.results)
	}

	static async obtainInfo(id: string): Promise<SiteInfo2[]> {
		const siteInfo = await SiteRepository.getSiteInfos(id)
		const withSvg = siteInfo.map(async (info) => {
			let svg = ''
			if (info.icon) svg = await MediaRepository.getSvg(info.icon)
			return { ...info, icon: svg }
		})

		return await Promise.all(withSvg)
	}

	static async obtainBy(idOrSubdomain: string): Promise<Site> {
		return await SiteRepository.getSite(idOrSubdomain)
	}

	static async getBySubdomain(subdomain: string): Promise<Site> {
		return await SiteRepository.getSiteBySubdomain(subdomain)
	}

	static async getDestinationBlocks(id: string): Promise<Block2<Destination2>[]> {
		return await SiteRepository.getDestinationBlocks(id)
	}

	static async getProducts(id: string): Promise<Block2<Product>[]> {
		const blocks: Block2<Product>[] = await SiteRepository.getProducts(id)
		return this.getProductsWithCovers(blocks)
	}

	static async getRecommendedSpots(siteId: string): Promise<Spot2[]> {
		try {
			const spots: Spot2[] = await SiteRepository.getRecommendedSpots(siteId)
			return spots.filter((spot: Spot2) => spot.cover)
		} catch {
			return []
		}
	}

	private static getProductsWithCovers(blocks: Block2<Product>[]): Block2<Product>[] {
		blocks.map((productBlock: Block2<Product>) => {
			const filtered = productBlock.content?.filter((product: Product) => product.coverUrls)
			productBlock.content = filtered
		})
		return blocks
	}

	static async getProductsByCategory(
		siteId: string,
		category: PRODUCT_CATEGORY
	): Promise<Product[]> {
		return await SiteRepository.getProductsByCategory(siteId, category)
	}
}
